module.exports = __webpack_public_path__ + "static/media/pagos_viejo.6f54f523.svg";